var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusRequestDisabled = function SvgMinusRequestDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.999,
    cy: 16.001,
    r: 13.333,
    fill: "#FFF3EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757D86",
    d: "M15.999 2.668a13.333 13.333 0 1 0 13.333 13.333A13.35 13.35 0 0 0 15.999 2.668m5.128 14.359h-4.103v4.102a1.026 1.026 0 0 1-2.051 0v-4.102H10.87a1.025 1.025 0 1 1 0-2.051h4.103v-4.103a1.025 1.025 0 1 1 2.051 0v4.103h4.103a1.026 1.026 0 1 1 0 2.05"
  })));
};
export default SvgMinusRequestDisabled;